module.exports = __webpack_public_path__ + "static/media/KH.7915296d.png";